module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter sgc-6",
    attrs: {
      "id": "chapter1",
      "title": "PART I"
    }
  }, [_c('div', {
    staticClass: "header sgc-2"
  }, [_c('h3', {
    staticClass: "sgc-1"
  }, [_vm._v("Part I")]), _vm._v(" "), _c('h4', {
    staticClass: "sgc-7",
    attrs: {
      "id": "sigil_toc_id_1"
    }
  }, [_vm._v("Underground")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-8"
  }, [_vm._v("The author of the diary and the diary itself are, of course, imaginary. Nevertheless it is clear that such persons as the writer of these notes not only may, but positively must, exist in our society, when we consider the circumstances in the midst of which our society is formed. I have tried to expose to the view of the public more distinctly than is commonly done, one of the characters of the recent past. He is one of the representatives of a generation still living. In this fragment, entitled “Underground,” this person introduces himself and his views, and, as it were, tries to explain the causes owing to which he has made his appearance and was bound to make his appearance in our midst. In the second fragment there are added the actual notes of this person concerning certain events in his life. — AUTHOR’S NOTE.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b139a87","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/content_0001.vue
// module id = 60
// module chunks = 0